import React from 'react';
import { Layout, Search, Smartphone, Settings, Shield } from 'lucide-react';
import { portfolioData } from '../mock';

const Services = () => {
  const iconMap = {
    layout: Layout,
    search: Search,
    smartphone: Smartphone,
    settings: Settings,
    shield: Shield
  };

  return (
    <section id="services" className="py-20 px-6 lg:px-8 bg-[#F8FAFC]">
      <div className="max-w-6xl mx-auto">
        <div className="mb-20">
          <h2 className="text-5xl sm:text-6xl font-bold text-black mb-6">
            Leistungen
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl">
            Was ich für Sie tun kann
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5DFD5]">
          {portfolioData.services.map((service) => {
            const Icon = iconMap[service.icon] || Layout;
            return (
              <div
                key={service.id}
                className="bg-[#F8FAFC] p-8 hover:bg-[#F1F5F9] transition-colors group"
              >
                <Icon className="text-[#1E40AF] mb-6" size={32} />
                <h3 className="text-xl font-bold text-black mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;